"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation uploadFiles($files: [Upload!]!, $isMultiImage: Boolean) {
    uploadFiles(files: $files, isMultiImage: $isMultiImage) {
      filename
      mimetype
      encoding
      url
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=uploadFiles.mutation.js.map